import { Spinner } from "@nextui-org/react";

import { Col, Text } from "@/components/customComponents";

const ScreenLoader = () => {
  return (
    <div className="fixed h-full w-full grid place-items-center bg-[rgb(0,0,0,0.5)] z-[99999] top-0 left-0">
      <Col className="w-min" gap={1}>
        <Spinner size="lg" />
        <Text>Loading...</Text>
      </Col>
    </div>
  );
};

export default ScreenLoader;
